import { create } from 'zustand';

interface LoginModalStore {
	loginModalLoadFailure: boolean;
	loginModalLoading: boolean;
	setLoginModalLoadFailed: () => void;
	setModalLoaded: () => void;
}

export const useLoginModalStore = create<LoginModalStore>((set) => ({
	loginModalLoadFailure: false,
	loginModalLoading: true,
	setLoginModalLoadFailed: () => {
		set({ loginModalLoadFailure: true });
		set({ loginModalLoading: false });
	},
	setModalLoaded: () => set({ loginModalLoading: false })
}));
